module.exports = __webpack_public_path__ + "img/power_tower.d67612a6.svg";